import { defineStore } from 'pinia'
import { computed } from 'vue'

import { useBrainyStore } from '@/hooks'
import { useMemberStore } from '@/stores/member.store'
import { AuthorModel } from '@/stores/models/AuthorModel'

export type Author = AuthorModel

export const useAuthorStore = defineStore('authors', () => {
  const state = useBrainyStore<Author>('authors', {
    model: 'AuthorDTO',
    makeModel: (attrs) => new AuthorModel(attrs),
    relations: ['user'],
    resolveRelation: (name, target) => {
      if (name == 'user') {
        const members = useMemberStore()
        return members.userById(target.user_id)
      }
    },
  })

  const groupedByDocument = state.$groupedBy('document_id', {
    multiple: true,
  })

  return {
    ...state,

    groupedByDocument,
    byDocumentId: computed(() => {
      return (id: Author['document_id']) => {
        return groupedByDocument.value[id]
      }
    }),
  }
})
